module.exports = __webpack_public_path__ + "img/chat.2a955f50.svg";